import {BBModel} from '../../bb_model';
import {BaseModel} from '../base';
import {BBService} from '../../bb_service';
import {clientDetails} from '../../services/client_details';

class ClientDetailsModel extends BaseModel {

    constructor(data) {
        super(...arguments);

        let questions = [];
        if (data) {
            questions = Array.from(data.questions).map(question => new BBModel.Question(question));
        }

        this.questions = BBService.question.groupConditionalQuestions(questions);
        this.hasQuestions = this.questions.length > 0;
    }

    /**
     * @ngdoc method
     * @name setAnswersFromQuestions
     * @methodOf BB:ClientDetails
     * @description
     * Set answers of the client details questions.
     */
    setAnswers(answers) {
        BBService.question.fillQuestionsWithAnswers(this.questions, answers);
    }

    /**
     * @ngdoc method
     * @name setAnswersFromQuestions
     * @methodOf BB:ClientDetails
     * @description
     * Set answers of the client details in function of answers.
     */
    setAnswersFromQuestions(questions) {
        const answers = BBService.question.getAnswers(questions);
        BBService.question.fillQuestionsWithAnswers(this.questions, answers);
    }

    /**
     * @ngdoc method
     * @name sortQuestions
     * @methodOf BB:ClientDetails
     *
     * @description
     * Sorts questions in a proper order depending on the company settings.
     */
    sortQuestions() {
        // Client questions should always be sorted according to their position.
        this.questions = BBService.question.sortQuestionsAccordingToPosition(this.questions);
    }

    /**
     * @description
     * Get post data from client details according to questions
     *
     * @returns {object} The returned data
     */
    getPostData() {
        return BBService.question.unwrapGroupedQuestions(this.questions)
            .filter(question => question.currentlyShown).map(question => question.getPostData());
    }

    static $query(company) {
        return clientDetails.query(company);
    }
}

export {
    ClientDetailsModel
};
